// Used by: LandingAgent (AnswerCard), WorkspaceAgent (WorkspaceTurn).
// Formats a raw numeric value into a display string based on an optional
// format hint: "currency" | "percent" | "count" | (unknown / omitted).
//
// Abbreviates >10K into K/M/B; preserves exact raw for smaller values.

export function formatKpiValue(raw: any, fmt?: string | null): string {
  if (raw === null || raw === undefined) return '—';
  const n = typeof raw === 'number' ? raw : Number(raw);
  if (!Number.isFinite(n)) return String(raw);
  const abbr = (x: number): string | null => {
    const abs = Math.abs(x);
    if (abs >= 1_000_000_000) return (x / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
    if (abs >= 1_000_000) return (x / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
    if (abs >= 10_000) return (x / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
    return null;
  };
  const f = (fmt || '').toLowerCase();
  if (f === 'currency' || f === 'usd' || f === 'dollars' || f === 'money') {
    const short = abbr(n);
    if (short) return '$' + short;
    return '$' + n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  if (f === 'percent' || f === '%') {
    return (Math.abs(n) > 1 ? n : n * 100).toFixed(1) + '%';
  }
  if (f === 'count' || f === 'integer' || f === 'int') {
    const short = abbr(n);
    if (short) return short;
    return Math.round(n).toLocaleString();
  }
  const short = abbr(n);
  if (short) return short;
  if (Number.isInteger(n)) return n.toLocaleString();
  return n.toLocaleString(undefined, { maximumFractionDigits: 2 });
}
